/*
 * View for the topic label modal
 */

define([
  "marionette",
  "modules/admin/userAdministration/userDetails/template/userDetailsModalTemplate.html",
], function (Marionette, UserDetailsModalTemplate) {
  var UserDetailsModalView = {};

  UserDetailsModalView.userDetailsModalLayout = Marionette.Layout.extend({
    template: UserDetailsModalTemplate,
    regions: {
      userDetails: "#userDetails",
      basicUserInfoDiv: "#basicUserInfoDiv",
      roleMapDiv: "#roleMapDiv",
      touchpointMapDiv: "#touchpointMapDiv",
      contextMapDiv: "#contextMapDiv",
      kbSelectDiv: "#kbSelectDiv",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    clearErrors: function () {
      this.$el.find("#roleError").html("");
    },
    roleError: function (errorMessage) {
      this.$el
        .find("#roleError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return UserDetailsModalView;
});
